import mixpanel from 'mixpanel-browser';

export const AuthEvents = {
  SignInOpsView: 'auth-sign-in-ops-view',
  SignInOktaView: 'auth-sign-in-okta-view',
};

export const DashboardEvents = {
  SourcingDashboardView: 'sourcing-dashboard-view',
  SourcingSuppliersView: 'sourcing-suppliers-view',
  SourcingSuppliersDetailView: 'sourcing-suppliers-detail-view',
  SourcingClientsView: 'sourcing-clients-view',
  SourcingClientsDetailView: 'sourcing-clients-detail-view',
};

export const AllEvents = {
  ...AuthEvents,
  ...DashboardEvents,
};

type AllEventTypeValues = typeof AllEvents[keyof typeof AllEvents];

type GenericEventData = Record<string, unknown>;

/**
 * Uses the cognito:username attribute since analytics is collected prior to a
 * user converting to a vendor in our system.
 */
export const setAnalyticsUserId = (userId: string) => {
  try {
    mixpanel.identify(userId);
  } catch (err) {
    console.error(err);
  }
};

export const addAnalyticsGroup = (groupKey: string, groupId: number | string) => {
  try {
    mixpanel.add_group(groupKey, groupId.toString());
  } catch (err) {
    console.error(err);
  }
};

export const removeAnalyticsGroup = (groupKey: string, groupId: number | string) => {
  try {
    mixpanel.remove_group(groupKey, groupId.toString());
  } catch (err) {
    console.error(err);
  }
};

export const trackEvent = <T = GenericEventData>(eventName: AllEventTypeValues, eventData: Partial<T> = {}) => {
  try {
    mixpanel.track(eventName, eventData);
  } catch (err) {
    console.error(err);
  }
};

export const reset = () => {
  try {
    mixpanel.reset();
  } catch (err) {
    console.error(err);
  }
};
